module.exports = __webpack_public_path__ + "img/mastercard.e9d23e93.svg";